export default __webpack_public_path__ + "static/media/image2.1bb12221.png";